module.exports = __webpack_public_path__ + "src/assets/img/was-alarm.acc097b6.svg";